import { loader, staticInit, initTrackers, SPARKY_FRAMEWORK } from './init'
import { __info } from './init/debug'
import './css/loading.css' // will generate loading.css outside of chunks
import './libs'

import type { FxScriptElement } from './init'
export type { SparkyFramework } from './framework'

const fxScript = document.querySelector('script[data-sparky-framework-loader]') as FxScriptElement
if (window.__SPARKY_LIBS__.sparkyFramework) {
  console.error('seems sparky framework been loaded more than once, please check your config.')
  alert('Sparky framework does not allow to be loaded more than once.')
}
else if (fxScript) {
  if (fxScript.details) {
    __info('init from shell loader')
    loader(fxScript)
    fxScript.removeAttribute('data-sparky-framework-loader')
  }
  else {
    __info('wait for shell loader init')
    fxScript.addEventListener('sparky-framework-loader', () => {
      if (fxScript.details) {
        __info('init with dynamic loader via shell loader')
        loader(fxScript)
      }
      else {
        console.error('failed to get details data from loader')
      }
    }, { once: true })
  }
}
else if (document.querySelector('script[data-sparky-loader]')) {
  __info('waiting for init event')
  document.addEventListener('sparky-loader-init', staticInit, { once: true })
  initTrackers() // no wait
}
else if (document.readyState === 'loading') {
  if (document.querySelector(`script[data-micro-app='${SPARKY_FRAMEWORK}']`)) {
    __info('waiting for dom load and init')
    document.addEventListener('DOMContentLoaded', staticInit, { once: true })
    initTrackers() // no wait
  }
  else {
    __info('init with dynamic loader')
    loader()
  }
}
else if (document.querySelector(`script[data-micro-app='${SPARKY_FRAMEWORK}']`)) {
  __info('dom loaded and init')
  initTrackers()
  staticInit()
}
else {
  console.error('dom load without init')
}
